import { Spinner } from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";

import {
  getCreateTeamActiveRowText,
  getCreateTeamFailedRowText,
} from "./team-lobby-render-model.js";

type TeamSyntheticListItemProps =
  | {
      kind: "active";
      requestedName: string;
      visualStatus: "pending" | "in_progress";
    }
  | {
      kind: "failed";
      requestedName: string;
      onDismiss: () => void;
      dismissDisabled?: boolean;
    };

export const TeamSyntheticListItem = (props: TeamSyntheticListItemProps) => {
  if (props.kind === "active") {
    return (
      <div className="border-bzd-gray-100 bg-bzd-gray-50 text-bzd-gray-400 mb-4 flex w-full items-center gap-3 rounded-md border p-4">
        <Spinner size="tiny" />
        <span className="text-base font-medium">
          {getCreateTeamActiveRowText({
            requestedName: props.requestedName,
            visualStatus: props.visualStatus,
          })}
        </span>
      </div>
    );
  }

  return (
    <div
      className="text-bzd-gray-400 relative mb-4 w-full rounded-md border-2 border-dashed bg-white p-4 pr-12"
      style={{ borderColor: "var(--color-bzd-yellow-500)" }}
    >
      <span className="text-base font-medium">
        {getCreateTeamFailedRowText(props.requestedName)}
      </span>

      <button
        aria-label={`Dismiss failed office creation for ${props.requestedName}`}
        className="text-bzd-gray-400 hover:text-bzd-gray-300 absolute top-3 right-3 cursor-pointer transition-colors disabled:cursor-not-allowed disabled:opacity-50"
        disabled={props.dismissDisabled}
        onClick={props.onDismiss}
        type="button"
      >
        <DismissRegular className="size-5" />
      </button>
    </div>
  );
};
